import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';

export type PayChipVariant =
  | 'soft' | 'neutral' | 'indigo'
  | 'success' | 'warning' | 'danger' | 'info'
  | 'navy';

export type PayChipSize = 'default' | 'sm';

@Component({
  selector:    'pay-chip',
  standalone:  true,
  imports:     [CommonModule, LucideIconsModule],
  templateUrl: './pay-chip.component.html',
  styleUrls:   ['./pay-chip.component.scss'],
})
export class PayChipComponent {
  @Input() label:     string         = '';
  @Input() variant:   PayChipVariant = 'neutral';
  @Input() size:      PayChipSize    = 'default';
  @Input() removable: boolean        = false;

  @Output() removed = new EventEmitter<void>();

  get hostClasses(): string {
    const size = this.size === 'sm' ? 'pay-chip--sm' : '';
    return ['pay-chip', `pay-chip--${this.variant}`, size].filter(Boolean).join(' ');
  }

  onRemove(event: MouseEvent): void {
    event.stopPropagation();
    this.removed.emit();
  }
}
